import React from 'react'
import _ from 'lodash';
import moment from 'moment';
import $ from 'jquery';
import { filter } from 'lodash';
import ReportWorkLogTableCt from './ReportWorkLogTableCt'
import custJqAjax from '../../../commonJS/custJqAjax';
// import { loadOptions } from '../salesCases/SalesCasesTableCt';
import { optsGeneratorCommon } from '../../../commonComponents/DropDownMenu';
import { textInputOnChange } from '../../../commonJS/onFormChanges';
import DayPicker from '../../../commonComponents/DayPicker';
import Tooltip from '../../../commonComponents/Tooltip';

import {
	// Modal,
	Panel,
	Button,
	FormControl,
	FormGroup,
	ControlLabel,
	Col,
	Row,
	// Well
} from 'react-bootstrap';

import {
	MultiSelectField,
	EntrySelectField,
	TypeSelectField,
	DateSelect,
	DropDownMenu,
	OptionsGenerator,
} from './ReportPs'


export default class ReportCt extends React.Component {
	constructor(props) {
		super(props);

		this.handlers = {
			textInputOnChange: e => {
				textInputOnChange(e, this);
			}
		}

		this.ajaxsWip = [];

		// this.loadSalesCasesOpts = (optsType, cb) => {
		// 	loadOptions(this, optsType, cb)
		// };

		this.tempFunc = () => { };

		this.state = {
			is_loading: false,
			selectedRepairStatus: '', // 已選維修狀態
			selectedCaseStatus: '', // 已選個案狀態
			selectedCaseType: '', // 已選個案類型
			selectedCaseProbability: '', // 已選個案結案機率
			selectedCaseSource: '',
			selectedCasePurchmentStatus: '',
			optsCompany: [],
			optsCaseType: [],
			optsCaseProbability: [],
			optsCaseSource: [],
			optsCasePayment: [],
			optsCaseRemindCyc: [],
			optsCasePurchmentStatus: [],
			optsCaseCurrency: [],
			// 8大表單會用到的選項
			optsCaseStatus: [],
			optsTypeStatus: [],
			optsStage: [],
			optsTake: [],
			optsTakeType: [],
			optsModelStatus: [],
			optsDelivery: [],
			optsCurrency: [],
			optsTax: [],
			optsMchineType_sales: [],
			optsMchineType_svc: [],
			optsmTypeStatus: [],
			optsOrderStatus: [],
			optsPurchaseType: [],
			optsTradeStatus: [],
			optsbDelivery: [],
			optsbDeliveryStstus: [],
			optsLading: [],
			optsInvoicePurpose: [],
			optsRepairStstus: [],
			optsWarehouse: [],
			optsInvoiceHandle: [],
			optsReason: [],
			optsBrand: [],
			optsReviewStatus: [],
			optsContractData: [],
			optsAreaData: [],
			optsServiceData: [],
			optsSatisfactionData: [],
			optsRepairStatus: [],
			selectedReportType: '',
			selectedReportList: [],
			filterTarget: 'all', //查詢單位, 預設'all'
			searchFrom: moment(), //拜訪日期的起
			searchUtil: moment(), //拜訪日期的迄
			selectedWorkNature: '',//已選擇的工作性質
			workNatureList: [], //工作性質的options
			selectedProgressStatus: '',//已選擇的工作進度
			progressStatusList: [], //工作進度的options
			selectedProjectProgress: '', //已選擇的工作進度
			projectProgressList: [], //專案進度的options
			mutiSelectOptions: [],//複選的options, 成員or部門
			selectAll: true, //是否查詢全部
			showWorkLogPanel: false, //是否顯示工作日誌的Panel, 查詢前預設false
			isHideFilterPanel: false, //是否隱藏查詢目標的Panel, 查詢前預設false
			multiSelectedValues: [],//已選擇的
			dataParam: '',//查詢API的param
			docId: '',
			customerId: '',
			contactName: '',
			bInvoicePurpose: [],
			deliveryDateStart: null,
			deliveryDateEnd: null,
			invoiceDateStart: null,
			invoiceDateEnd: null,
			purchaseDateStart: null,
			purchaseDateEnd: null,
			contractDateStart: null,
			contractDateEnd: null,
			quotationDateStart: null,
			quotationDateEnd: null,
			createDateStart: null,
			createDateEnd: null,
			openDateStart: null,
			openDateEnd: null,
			takeDateStart: null,
			takeDateEnd: null,
			dueDateStart: null,
			dueDateEnd: null,
			requestDateStart: null,
			requestDateEnd: null,
			leaveTimeStart: null,
			leaveTimeEnd: null,
			paymentDateStart: null,
			paymentDateEnd: null
		}
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onChangeDate = this.onChangeDate.bind(this);
		this.onClickSend = this.onClickSend.bind(this);
		this.onChangeDropdownHandler = this.onChangeDropdownHandler.bind(this);
		this.multiSelectChangeHandler = this.multiSelectChangeHandler.bind(this);
		this.multiOtherSelectChangeHandler = this.multiOtherSelectChangeHandler.bind(this);
		this.onClickFilterPanelDown = this.onClickFilterPanelDown.bind(this);
	}

	componentDidMount() {
		const { languageCode } = window.myConsts;

		const { userPermission } = this.props;

		// 報表功能清單
		const list = [
			// { value: 'workLog', label: '工作日誌', permission: '' },
			// { value: 'salesCases', label: '銷售個案', permission: '' },
			{ value: 'repairService', label: '服務單', permission: 'salesky_report_repair_web' },
			{ value: 'repairServiceReview', label: '服務單-開會討論', permission: 'salesky_report_repair_web' },
			{ value: 'formQuotation', label: '估價單', permission: 'salesky_report_quotation_web' },
			// { value: 'formCost', label: '成本分析表', permission: '' },
			{ value: 'formMargin', label: '保證金申請單', permission: 'salesky_report_margin_web' },
			// { value: 'formOrder', label: '訂單', permission: '' },
			{ value: 'formGoods', label: '貨品申購書', permission: 'salesky_report_goods_web' },
			{ value: 'formLading', label: '領貨單', permission: 'salesky_report_lading_web' },
			{ value: 'formInvoice', label: '發票申請單', permission: 'salesky_report_invoice_web' },
			// { value: 'formWarehouse', label: '入庫單', permission: '' }
			{ value: 'formExpense', label: '預付費用單', permission: 'salesky_report_expense_web' }
		]

		let selectedReportList = [];
		_.forEach(list, (val, key) => {
			if (
				val.permission !== '' &&
				userPermission &&
				userPermission[val.permission] === '3'
			) selectedReportList.push(val)
		});
		this.setState({
			selectedReportList,
			selectedReportType: selectedReportList.length > 0 ? selectedReportList[0].value : ''
		})

		let
			apiUrl = '/api/M_Basic_Group_Data_Get.php',
			stateKey = [
				'optsTypeStatus',
				'optsStage',
				'optsTake',
				'optsModelStatus',
				'optsDelivery',
				'optsCurrency',
				'optsTax',
				'optsMchineType_sales',
				'optsMchineType_svc',
				'optsmTypeStatus',
				'optsOrderStatus',
				'optsCaseStatus',
				'optsPurchaseType',
				'optsTradeStatus',
				'optsbDelivery',
				'optsbDeliveryStstus',
				'optsLading',
				'optsInvoicePurpose',
				'optsWarehouse',
				'optsTakeType',
				'optsInvoiceHandle',
				'optsReason'
			];

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: apiUrl,
			processData: false,
			contentType: false,
			complete: res => {
				let options = [];

				if (res.responseJSON.status === '0') {
					const data = res.responseJSON.result;

					options.push(optsGeneratorCommon(filter(data, { group_name: 'type_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'stage_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'take_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'model_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'delivery_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'currency_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'tax_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'machine_type_sales' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'machine_type_svc' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'mtype_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'order_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'case_status' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'purchase_type' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'trade_id' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'delivery_type' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'delivery_status' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'lading_type' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'invoice_purpose' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'warehouse_type' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'take_type' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'invoice_handle' }), ['value', 'label'], ['key', 'value']));
					options.push(optsGeneratorCommon(filter(data, { group_name: 'reason_id' }), ['value', 'label'], ['key', 'value']));
				} else {
					options = [];
				}

				// 選項沒東西或出錯則不需更新
				if (options.length !== 0) {
					const tempObj = {};
					for (let i = stateKey.length - 1; i >= 0; i--) {
						tempObj[stateKey[i]] = options[i];
					}

					this.setState(tempObj);
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_Brand_Ref_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = res.responseJSON.result;

					this.setState({
						optsBrand: optsGeneratorCommon(data, ['value', 'label'], ['id', 'brand_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_Flowstatus_Ref_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = res.responseJSON.result;

					this.setState({
						optsReviewStatus: optsGeneratorCommon(data, ['value', 'label'], ['flowstatus_id', 'flowstatus_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_ServiceSky_RepairSky_Status_Lang_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = filter(res.responseJSON.result, { lang_code: languageCode });

					this.setState({
						optsRepairStatus: optsGeneratorCommon(data, ['value', 'label', 'color'], ['status_id', 'status_name', 'color_code'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_ServiceSky_RepairSky_Area_Type_Lang_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = filter(res.responseJSON.result, { lang_code: languageCode });

					this.setState({
						optsAreaData: optsGeneratorCommon(data, ['value', 'label'], ['area_type_id', 'area_type_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_ServiceSky_RepairSky_Service_Type_Lang_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = filter(res.responseJSON.result, { lang_code: languageCode });

					this.setState({
						optsServiceData: optsGeneratorCommon(data, ['value', 'label'], ['service_type_id', 'service_type_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_ServiceSky_RepairSky_Satisfaction_Type_Lang_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = filter(res.responseJSON.result, { lang_code: languageCode });

					this.setState({
						optsSatisfactionData: optsGeneratorCommon(data, ['value', 'label'], ['satisfaction_id', 'satisfaction_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_ServiceSky_RepairSky_Warranty_Type_Lang_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = filter(res.responseJSON.result, { lang_code: languageCode });

					this.setState({
						optsContractData: optsGeneratorCommon(data, ['value', 'label'], ['warranty_type_id', 'warranty_type_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_ServiceSky_Repair_Sky_Status_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = filter(res.responseJSON.result, { lang: languageCode });

					this.setState({
						optsRepairStstus: optsGeneratorCommon(data, ['value', 'label'], ['id', 'name'])
					})
				}
			}
		});

		this.loadData();
		this.getUsers();
		// this.getClientHeight();
		// this.loadSalesCasesOpts('salesCaseOptions');
	}

	componentWillUnmount() {
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
	}

	// getClientHeight() {
	// 	//先抓瀏覽器高度 我覺得是一個有損效能的事情 不過等到改版後再重新切版吧
	// 	let navbarContainerHeight = 63 + 20;
	// 	let div_reportCtHeight = $(window).height() - navbarContainerHeight;
	// 	$('.div-reportCt').css('height', div_reportCtHeight + 'px');
	// }

	loadData() {
		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_SaleSky_WorkNature.php',
			success: data => {
				let workNatureList = data.result;
				this.setState({
					workNatureList: workNatureList,
				});
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_SaleSky_ProgressStatus.php',
			success: data => {
				let progressStatusList = data.result;
				this.setState({
					progressStatusList: progressStatusList,
				});
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_SaleSky_ProjectProgress.php',
			success: data => {
				let projectProgressList = data.result;
				this.setState({
					projectProgressList: projectProgressList,
				});
			}
		});
	}

	onChangeHandler(event, fieldName) {
		let newState = {};
		newState[fieldName] = event.value;

		this.setState(newState, () => {
			switch (this.state.selectedReportType) {
				case 'formMargin':
				case 'formExpense':
				case 'formLading':
				case 'formInvoice':
				case 'formQuotation':
				case 'formGoods':
					this.getUsers();
					break;

				default:
			}
		});

		if (fieldName === 'filterTarget') this.showMultiSelectField(event.value);
	}

	onChangeDropdownHandler(selectedObject, fieldName) {
		let newState = {};
		newState[fieldName] = selectedObject.value;
		this.setState(newState);
	}

	showMultiSelectField(filterTarget) {
		if (filterTarget === 'member') {
			this.getUsers(); //當查詢目標是成員, load所有的成員
		} else if (filterTarget === 'group') {
			this.getGroups(); //當查詢目標是部門, load所有的部門
		} else {
			this.setState({
				selectAll: true,
			});
		}
	}

	getUsers() {
		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_SaleSky_Users.php',
			success: data => {
				let users = data.result;
				let userList = [];
				for (let i = 0; i < users.length; i++) {
					let aUser = { value: users[i].id, label: users[i].name }
					userList.push(aUser);
				}
				this.setState({
					mutiSelectOptions: userList,
					selectAll: false,
				});
			}
		});
	}

	getGroups() {
		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_SaleSky_UserGroup.php',
			success: data => {
				let groups = data.result;
				let groupList = [];
				for (let i = 0; i < groups.length; i++) {
					let aGroup = { value: groups[i].id, label: groups[i].name }
					groupList.push(aGroup);
				}
				this.setState({
					mutiSelectOptions: groupList,
					selectAll: false,
				});
			}
		});
	}

	multiSelectChangeHandler(value) {
		this.setState({ multiSelectedValues: value });
	}

	multiOtherSelectChangeHandler(value) {
		switch (this.state.selectedReportType) {
			case 'repairService':
				this.setState({ selectedRepairStatus: value });
				break;
			case 'formInvoice':
				this.setState({ bInvoicePurpose: value });
				break;

			default:
		}
	}

	onChangeDate(type, date) {
		let newState = {};
		newState[type] = date;
		this.setState(newState);
	}

	onClickSend() {
		this.setState({ is_loading: true })

		let {
			searchFrom,
			searchUtil,
			multiSelectedValues,
			selectedWorkNature,
			selectedProgressStatus,
			selectedProjectProgress,
			selectedRepairStatus,
			// salesCases
			selectedCaseStatus,
			selectedCaseType,
			selectedCaseProbability,
			selectedCaseSource,
			selectedCasePurchmentStatus,
			filterTarget,
			docId,
			customerId,
			contactName,
			bInvoicePurpose,
			deliveryDateStart,
			deliveryDateEnd,
			invoiceDateStart,
			invoiceDateEnd,
			purchaseDateStart,
			purchaseDateEnd,
			contractDateStart,
			contractDateEnd,
			quotationDateStart,
			quotationDateEnd,
			requestDateStart,
			requestDateEnd,
			leaveTimeStart,
			leaveTimeEnd,
			createDateStart,
			createDateEnd,
			openDateStart,
			openDateEnd,
			takeDateStart,
			takeDateEnd,
			dueDateStart,
			dueDateEnd,
			paymentDateStart,
			paymentDateEnd
		} = this.state;

		let data, apiUrl;

		switch (this.state.selectedReportType) {
			case 'workLog':
				data = {
					user_id: filterTarget === 'member' ? multiSelectedValues : '',
					group_id: filterTarget === 'group' ? multiSelectedValues : '',
					visit_start_date: searchFrom.format('YYYY-MM-DD'),
					visit_end_date: searchUtil.format('YYYY-MM-DD'),
					nature_id: selectedWorkNature,//工作性質
					progress_id: selectedProgressStatus,//工作進度
					project_progress_id: selectedProjectProgress,//專案進度
				};
				break;
			case 'salesCases':
				data = {
					user_id: filterTarget === 'member' ? multiSelectedValues : '',
					group_id: filterTarget === 'group' ? multiSelectedValues : '',
					start_date: searchFrom.format('YYYY-MM-DD'),
					end_date: searchUtil.format('YYYY-MM-DD'),
					case_stage: selectedCaseStatus || 0,
					case_type: selectedCaseType || 0,
					case_closerate: selectedCaseProbability || 0,
					case_source: selectedCaseSource || 0,
					case_buyissue: selectedCasePurchmentStatus || 0
				};
				break;
			case 'repairService':
				data = {
					status: selectedRepairStatus,
					request_date_start: requestDateStart ? moment(requestDateStart).format('YYYY-MM-DD') : '',
					request_date_end: requestDateEnd ? moment(requestDateEnd).format('YYYY-MM-DD') : '',
					leave_time_start: leaveTimeStart ? moment(leaveTimeStart).format('YYYY-MM-DD') : '',
					leave_time_end: leaveTimeEnd ? moment(leaveTimeEnd).format('YYYY-MM-DD') : ''
				};
				apiUrl = `M_ServiceSky_RepairSky_Report_Excel_Get.php?${$.param(data)}`;
				break;
			case 'repairServiceReview':
				data = {
					fix_user_id: multiSelectedValues
				};
				apiUrl = `M_ServiceSky_RepairSky_Review_Excel_Get.php?${$.param(data)}`;
				break;
			case 'formQuotation':
				data = {
					doc_id: docId,
					request_id: multiSelectedValues,
					customer_id: customerId,
					contact_name: contactName,
					quotation_date_start: quotationDateStart ? moment(quotationDateStart).format('YYYY-MM-DD') : '',
					quotation_date_end: quotationDateEnd ? moment(quotationDateEnd).format('YYYY-MM-DD') : ''
				};
				apiUrl = `M_Quotation_Data_Report_Excel_Get.php?${$.param(data)}`;
				break;
			case 'formCost':
			case 'formOrder':
			case 'formWarehouse':
				data = {}
				break;
			case 'formGoods':
				data = {
					doc_id: docId,
					request_id: multiSelectedValues,
					customer_id: customerId,
					contact_name: contactName,
					purchase_date_start: purchaseDateStart ? moment(purchaseDateStart).format('YYYY-MM-DD') : '',
					purchase_date_end: purchaseDateEnd ? moment(purchaseDateEnd).format('YYYY-MM-DD') : '',
					contract_date_start: contractDateStart ? moment(contractDateStart).format('YYYY-MM-DD') : '',
					contract_date_end: contractDateEnd ? moment(contractDateEnd).format('YYYY-MM-DD') : '',
					delivery_date_start: deliveryDateStart ? moment(deliveryDateStart).format('YYYY-MM-DD') : '',
					delivery_date_end: deliveryDateEnd ? moment(deliveryDateEnd).format('YYYY-MM-DD') : ''
				};
				apiUrl = `M_Goods_Data_Report_Excel_Get.php?${$.param(data)}`;
				break;
			case 'formLading':
				data = {
					doc_id: docId,
					request_id: multiSelectedValues,
					customer_id: customerId,
					contact_name: contactName,
					delivery_date_start: deliveryDateStart ? moment(deliveryDateStart).format('YYYY-MM-DD') : '',
					delivery_date_end: deliveryDateEnd ? moment(deliveryDateEnd).format('YYYY-MM-DD') : '',
					invoice_date_start: invoiceDateStart ? moment(invoiceDateStart).format('YYYY-MM-DD') : '',
					invoice_date_end: invoiceDateEnd ? moment(invoiceDateEnd).format('YYYY-MM-DD') : ''
				};
				apiUrl = `M_Lading_Data_Report_Excel_Get.php?${$.param(data)}`;
				break;
			case 'formInvoice':
				data = {
					doc_id: docId,
					request_id: multiSelectedValues,
					customer_id: customerId,
					contact_name: contactName,
					b_invoice_purpose: bInvoicePurpose,
					delivery_date_start: deliveryDateStart ? moment(deliveryDateStart).format('YYYY-MM-DD') : '',
					delivery_date_end: deliveryDateEnd ? moment(deliveryDateEnd).format('YYYY-MM-DD') : '',
					invoice_date_start: invoiceDateStart ? moment(invoiceDateStart).format('YYYY-MM-DD') : '',
					invoice_date_end: invoiceDateEnd ? moment(invoiceDateEnd).format('YYYY-MM-DD') : ''
				};
				apiUrl = `M_Invoice_Data_Report_Excel_Get.php?${$.param(data)}`;
				break;
			case 'formMargin':
				data = {
					request_id: multiSelectedValues,
					create_date_start: createDateStart ? moment(createDateStart).format('YYYY-MM-DD') : '',
					create_date_end: createDateEnd ? moment(createDateEnd).format('YYYY-MM-DD') : '',
					open_date_start: openDateStart ? moment(openDateStart).format('YYYY-MM-DD') : '',
					open_date_end: openDateEnd ? moment(openDateEnd).format('YYYY-MM-DD') : '',
					take_date_start: takeDateStart ? moment(takeDateStart).format('YYYY-MM-DD') : '',
					take_date_end: takeDateEnd ? moment(takeDateEnd).format('YYYY-MM-DD') : '',
					due_date_start: dueDateStart ? moment(dueDateStart).format('YYYY-MM-DD') : '',
					due_date_end: dueDateEnd ? moment(dueDateEnd).format('YYYY-MM-DD') : '',
				};
				apiUrl = `M_Margin_Data_Report_Excel_Get.php?${$.param(data)}`;
				break;
			case 'formExpense':
				data = {
					request_id: multiSelectedValues,
					request_date_start: requestDateStart ? moment(requestDateStart).format('YYYY-MM-DD') : '',
					request_date_end: requestDateEnd ? moment(requestDateEnd).format('YYYY-MM-DD') : '',
					payment_date_start: paymentDateStart ? moment(paymentDateStart).format('YYYY-MM-DD') : '',
					payment_date_end: paymentDateEnd ? moment(paymentDateEnd).format('YYYY-MM-DD') : '',
				};
				apiUrl = `M_Expense_Data_Report_Excel_Get.php?${$.param(data)}`;
				break;

			default:
		}

		// data = $.param(data);

		// this.setState({ dataParam: data }, () => {
		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: `/api/${apiUrl}`,
			processData: false,
			contentType: false,
			success: res => {
				this.setState({ is_loading: false })

				const dataRes = res.result;
				if (res.status === '0') {
					let link = document.createElement('a');
					if (link.download !== undefined) {
						let url = dataRes[0].file_path;
						link.setAttribute('href', url);
						link.style.visibility = 'hidden';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
				} else alert('查無資料');
			}
		})

		// });

		// this.clearForm();
	}

	clearForm() {
		this.setState({
			showWorkLogPanel: true,
			isHideFilterPanel: true,
			//filterTarget: 'all',
			//searchFrom: moment(),
			//searchUtil: moment(),
			//selectedWorkNature: '',
			//selectedProgressStatus: '',
			//selectedProjectProgress: '',
			//selectAll: true,
			//multiSelectedValues: [],
			// selectedCaseStatus: '',
			// selectedCaseType: '',
			// selectedCaseProbability: ''
		});
	}

	onClickFilterPanelDown() {
		this.setState({
			showWorkLogPanel: false,
			isHideFilterPanel: false,
		});
	}

	render() {
		const {
			userId,
			userName,
			closeModal,
			propsPackageFromSkyFamily,
			isBigSideBar,
		} = this.props;

		let {
			searchFrom,
			searchUtil,
			workNatureList,
			progressStatusList,
			projectProgressList,
			selectedProgressStatus,
			selectedWorkNature,
			selectedProjectProgress,
			selectedRepairStatus,
			selectedCaseStatus,
			selectedCaseType,
			selectedCaseProbability,
			selectedCaseSource,
			selectedCasePurchmentStatus,
			filterTarget,
			selectAll,
			showWorkLogPanel,
			isHideFilterPanel,
			multiSelectedValues,
			mutiSelectOptions,
			dataParam,
			selectedReportType,
			selectedReportList,
			optsCompany,
			optsCaseType,
			optsCaseProbability,
			optsCaseSource,
			optsCasePayment,
			optsCaseRemindCyc,
			optsCasePurchmentStatus,
			optsCaseCurrency,
			optsCaseStatus,
			optsTypeStatus,
			optsStage,
			optsTake,
			optsTakeType,
			optsModelStatus,
			optsDelivery,
			optsCurrency,
			optsTax,
			optsMchineType_sales,
			optsMchineType_svc,
			optsmTypeStatus,
			optsOrderStatus,
			optsPurchaseType,
			optsTradeStatus,
			optsbDelivery,
			optsbDeliveryStstus,
			optsLading,
			optsInvoicePurpose,
			optsRepairStstus,
			optsWarehouse,
			optsInvoiceHandle,
			optsReason,
			optsBrand,
			optsReviewStatus,
			optsContractData,
			optsAreaData,
			optsServiceData,
			optsSatisfactionData,
			optsRepairStatus
		} = this.state;

		let options_workNature = OptionsGenerator(workNatureList),
			options_progressStatus = OptionsGenerator(progressStatusList),
			options_projectProgress = OptionsGenerator(projectProgressList);

		let title1, title2, title3, title4, title5, label1, label2, label3, label4, label5,
			value1, value2, value3, value4, value5, opts1, opts2, opts3, opts4, opts5, tableTitle,
			tableProps;

		switch (selectedReportType) {
			case 'workLog':
				title1 = '工作性質';
				title2 = '工作進度';
				title3 = '專案進度';
				label1 = 'selectedWorkNature';
				label2 = 'selectedProgressStatus';
				label3 = 'selectedProjectProgress';
				value1 = selectedWorkNature;
				value2 = selectedProgressStatus;
				value3 = selectedProjectProgress;
				opts1 = options_workNature;
				opts2 = options_progressStatus;
				opts3 = options_projectProgress;

				tableTitle = '工作日誌';

				tableProps = {
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar,
					propsPackageFromSkyFamily
				}
				break;
			case 'salesCases':
				title1 = '目前狀態';
				title2 = '個案分類';
				title3 = '結案機率';
				title4 = '客戶來源';
				title5 = '採購狀態';

				label1 = 'selectedCaseStatus';
				label2 = 'selectedCaseType';
				label3 = 'selectedCaseProbability';
				label4 = 'selectedCaseSource';
				label5 = 'selectedCasePurchmentStatus';

				value1 = selectedCaseStatus;
				value2 = selectedCaseType;
				value3 = selectedCaseProbability;
				value4 = selectedCaseSource;
				value5 = selectedCasePurchmentStatus;

				opts1 = optsCaseStatus;
				opts2 = optsCaseType;
				opts3 = optsCaseProbability;
				opts4 = optsCaseSource;
				opts5 = optsCasePurchmentStatus;
				// opts4 = options_caseSource;
				// opts5 = options_casePurchMentStatus;

				tableTitle = '銷售個案';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// loadOptions: this.loadSalesCasesOpts,
					optsCompany,
					optsCaseStatus,
					optsCaseType,
					optsCaseProbability,
					optsCaseSource,
					optsCasePayment,
					optsCaseRemindCyc,
					optsCasePurchmentStatus,
					optsCaseCurrency,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					// selectedRowIndex: state.selectedRowIndex,
					// selectedItemId: state.selectedItemId,
					// onRowClick: this.handlers.onRowClick,
					productProps: { productSortedData: { _data: true } },
					// optsModel: state.optsModel,
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'repairService':
				tableTitle = '服務單';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// loadOptions: this.loadSalesCasesOpts,
					optsCompany,
					optsContractData,
					optsAreaData,
					optsServiceData,
					optsSatisfactionData,
					optsRepairStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					// selectedRowIndex: state.selectedRowIndex,
					// selectedItemId: state.selectedItemId,
					// onRowClick: this.handlers.onRowClick,
					productProps: { productSortedData: { _data: true } },
					// optsModel: state.optsModel,
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'repairServiceReview':
				tableTitle = '服務單-開會討論';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// loadOptions: this.loadSalesCasesOpts,
					optsCompany,
					optsContractData,
					optsAreaData,
					optsServiceData,
					optsSatisfactionData,
					optsRepairStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					// selectedRowIndex: state.selectedRowIndex,
					// selectedItemId: state.selectedItemId,
					// onRowClick: this.handlers.onRowClick,
					productProps: { productSortedData: { _data: true } },
					// optsModel: state.optsModel,
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'formQuotation':
				tableTitle = '估價單';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// optsCompany,
					optsCaseStatus,
					optsTypeStatus,
					optsStage,
					optsTake,
					optsTakeType,
					optsModelStatus,
					optsDelivery,
					optsCurrency,
					optsTax,
					optsMchineType_sales,
					optsMchineType_svc,
					optsmTypeStatus,
					optsOrderStatus,
					optsPurchaseType,
					optsTradeStatus,
					optsbDelivery,
					optsbDeliveryStstus,
					optsLading,
					optsInvoicePurpose,
					optsWarehouse,
					optsInvoiceHandle,
					optsReason,
					optsBrand,
					optsReviewStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					productProps: { productSortedData: { _data: true } },
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'formCost':
				tableTitle = '成本分析表';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// optsCompany,
					optsCaseStatus,
					optsTypeStatus,
					optsStage,
					optsTake,
					optsTakeType,
					optsModelStatus,
					optsDelivery,
					optsCurrency,
					optsTax,
					optsMchineType_sales,
					optsMchineType_svc,
					optsmTypeStatus,
					optsOrderStatus,
					optsPurchaseType,
					optsTradeStatus,
					optsbDelivery,
					optsbDeliveryStstus,
					optsLading,
					optsInvoicePurpose,
					optsWarehouse,
					optsInvoiceHandle,
					optsReason,
					optsBrand,
					optsReviewStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					productProps: { productSortedData: { _data: true } },
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'formOrder':
				tableTitle = '訂單';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// optsCompany,
					optsCaseStatus,
					optsTypeStatus,
					optsStage,
					optsTake,
					optsTakeType,
					optsModelStatus,
					optsDelivery,
					optsCurrency,
					optsTax,
					optsMchineType_sales,
					optsMchineType_svc,
					optsmTypeStatus,
					optsOrderStatus,
					optsPurchaseType,
					optsTradeStatus,
					optsbDelivery,
					optsbDeliveryStstus,
					optsLading,
					optsInvoicePurpose,
					optsWarehouse,
					optsInvoiceHandle,
					optsReason,
					optsBrand,
					optsReviewStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					productProps: { productSortedData: { _data: true } },
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'formGoods':
				tableTitle = '貨品申購書';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// optsCompany,
					optsCaseStatus,
					optsTypeStatus,
					optsStage,
					optsTake,
					optsTakeType,
					optsModelStatus,
					optsDelivery,
					optsCurrency,
					optsTax,
					optsMchineType_sales,
					optsMchineType_svc,
					optsmTypeStatus,
					optsOrderStatus,
					optsPurchaseType,
					optsTradeStatus,
					optsbDelivery,
					optsbDeliveryStstus,
					optsLading,
					optsInvoicePurpose,
					optsWarehouse,
					optsInvoiceHandle,
					optsReason,
					optsBrand,
					optsReviewStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					productProps: { productSortedData: { _data: true } },
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'formLading':
				tableTitle = '領貨單';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// optsCompany,
					optsCaseStatus,
					optsTypeStatus,
					optsStage,
					optsTake,
					optsTakeType,
					optsModelStatus,
					optsDelivery,
					optsCurrency,
					optsTax,
					optsMchineType_sales,
					optsMchineType_svc,
					optsmTypeStatus,
					optsOrderStatus,
					optsPurchaseType,
					optsTradeStatus,
					optsbDelivery,
					optsbDeliveryStstus,
					optsLading,
					optsInvoicePurpose,
					optsWarehouse,
					optsInvoiceHandle,
					optsReason,
					optsBrand,
					optsReviewStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					productProps: { productSortedData: { _data: true } },
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'formInvoice':
				tableTitle = '發票申請單';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// optsCompany,
					optsCaseStatus,
					optsTypeStatus,
					optsStage,
					optsTake,
					optsTakeType,
					optsModelStatus,
					optsDelivery,
					optsCurrency,
					optsTax,
					optsMchineType_sales,
					optsMchineType_svc,
					optsmTypeStatus,
					optsOrderStatus,
					optsPurchaseType,
					optsTradeStatus,
					optsbDelivery,
					optsbDeliveryStstus,
					optsLading,
					optsInvoicePurpose,
					optsWarehouse,
					optsInvoiceHandle,
					optsReason,
					optsBrand,
					optsReviewStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					productProps: { productSortedData: { _data: true } },
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;
			case 'formMargin':
			case 'formExpense':
				tableTitle = '';

				tableProps = {
					closeModal,
					propsPackageFromSkyFamily,
					// modal更新的始終是篩選前的資料
					sortedData: {},
					// for pagerUd
					filteredSortedData: {},
					// optsCompany,
					optsCaseStatus,
					optsTypeStatus,
					optsStage,
					optsTake,
					optsTakeType,
					optsModelStatus,
					optsDelivery,
					optsCurrency,
					optsTax,
					optsMchineType_sales,
					optsMchineType_svc,
					optsmTypeStatus,
					optsOrderStatus,
					optsPurchaseType,
					optsTradeStatus,
					optsbDelivery,
					optsbDeliveryStstus,
					optsLading,
					optsInvoicePurpose,
					optsWarehouse,
					optsInvoiceHandle,
					optsReason,
					optsBrand,
					optsReviewStatus,
					grandStateHandler: this.tempFunc, // props.stateHandler, // 上上上層
					stateHandler: this.tempFunc, // props.parentStateHandler, // 上上層
					parentStateHandler: this.tempFunc, // this.parentStateHandler, // 上層
					// 使用table裡面的
					productProps: { productSortedData: { _data: true } },
					userId,
					userName,
					reportType: selectedReportType,
					dataParam,
					isBigSideBar
				}
				break;

			default:
		}

		return (
			<div className='div-reportCt'>
				{
					this.state.is_loading ?
						<div className='loading'>
							<div className='loadingBG'></div>
							<img role='presentation' src='/imgs/loading.gif' alt='' />
						</div>
						: null
				}
				<Panel header={<h3>查詢目標</h3>} id='filterPanel'>
					<div id='div-filterElements' className={(isHideFilterPanel ? 'hidden' : '') + ' div-filterElements'}>
						{
							(
								selectedReportType === 'workLog' ||
								selectedReportType === 'salesCases'
							) ?
								<div>
									<Row>
										<Col sm={12}>
											<TypeSelectField
												onChangeHandler={this.onChangeHandler}
												value={selectedReportType}
												selectedReportList={selectedReportList} />
										</Col>
										<Col sm={4}>
											<EntrySelectField
												onChangeHandler={this.onChangeHandler}
												value={filterTarget} />
										</Col>
										<Col sm={4}>
											<DateSelect
												label='searchFrom'
												onChangeDate={this.onChangeDate}
												time={searchFrom} />
										</Col>
										<Col sm={4}>
											<DateSelect
												label='searchUtil'
												onChangeDate={this.onChangeDate}
												time={searchUtil} />
										</Col>
										{
											!selectAll ?
												<Col sm={12}>
													<MultiSelectField
														multiSelectOptions={mutiSelectOptions}
														multiSelectedValues={multiSelectedValues}
														onChange={this.multiSelectChangeHandler} />
												</Col>
												: ''
										}
										<Col sm={4}>
											<DropDownMenu
												required={false}
												title={title1}
												label={label1}
												value={value1}
												onChange={this.onChangeDropdownHandler}
												options={opts1} />
										</Col>
										<Col sm={4}>
											<DropDownMenu
												required={false}
												title={title2}
												label={label2}
												value={value2}
												onChange={this.onChangeDropdownHandler}
												options={opts2} />
										</Col>
										<Col sm={4}>
											<DropDownMenu
												required={false}
												title={title3}
												label={label3}
												value={value3}
												onChange={this.onChangeDropdownHandler}
												options={opts3} />
										</Col>
										{
											selectedReportType === 'salesCases' ?
												<div>
													<Col sm={4}>
														<DropDownMenu
															required={false}
															title={title4}
															label={label4}
															value={value4}
															onChange={this.onChangeDropdownHandler}
															options={opts4} />
													</Col>
													<Col sm={4}>
														<DropDownMenu
															required={false}
															title={title5}
															label={label5}
															value={value5}
															onChange={this.onChangeDropdownHandler}
															options={opts5} />
													</Col>
												</div>
												: ''
										}
										<Col sm={12}>
											<Button className='btn-search' onClick={this.onClickSend}>查詢</Button>
										</Col>
									</Row>
								</div>
								:
								<Row>
									<Col sm={12}>
										<TypeSelectField
											onChangeHandler={this.onChangeHandler}
											value={selectedReportType}
											selectedReportList={selectedReportList} />
									</Col>
									{
										(
											selectedReportType === 'repairService' ||
											selectedReportType === 'repairServiceReview' ||
											selectedReportType === 'formLading' ||
											selectedReportType === 'formInvoice' ||
											selectedReportType === 'formGoods' ||
											selectedReportType === 'formQuotation' ||
											selectedReportType === 'formMargin' ||
											selectedReportType === 'formExpense'
										) ?
											<Col sm={12}>
												<Row>
													{
														selectedReportType !== 'repairService' ?
															<div>
																{
																	(
																		selectedReportType !== 'repairServiceReview' &&
																		selectedReportType !== 'formMargin' &&
																		selectedReportType !== 'formExpense'
																	) ?
																		<Col sm={4}>
																			<FormGroup controlId='docId'>
																				<ControlLabel style={{ fontWeight: 'bold' }}>領貨單編號</ControlLabel>
																				<FormControl
																					type='text'
																					onChange={this.handlers.textInputOnChange}
																					value={this.state.docId}
																					style={{ height: 36 }} />
																			</FormGroup>
																		</Col>
																		: ''
																}
																<Col sm={4}>
																	<MultiSelectField
																		title={'使用者'}
																		multiSelectOptions={mutiSelectOptions}
																		multiSelectedValues={multiSelectedValues}
																		onChange={this.multiSelectChangeHandler} />
																</Col>
																{
																	(
																		selectedReportType !== 'repairServiceReview' &&
																		selectedReportType !== 'formMargin' &&
																		selectedReportType !== 'formExpense'
																	) ?
																		<Col sm={4}>
																			<FormGroup controlId='customerId'>
																				<ControlLabel style={{ fontWeight: 'bold' }}>客戶編號</ControlLabel>
																				<FormControl
																					type='text'
																					onChange={this.handlers.textInputOnChange}
																					value={this.state.customerId}
																					style={{ height: 36 }} />
																			</FormGroup>
																		</Col>
																		: ''
																}
																{
																	(
																		selectedReportType !== 'repairServiceReview' &&
																		selectedReportType !== 'formMargin' &&
																		selectedReportType !== 'formExpense'
																	) ?
																		<Col sm={4}>
																			<FormGroup controlId='contactName'>
																				<ControlLabel style={{ fontWeight: 'bold' }}>聯絡人名稱</ControlLabel>
																				<FormControl
																					type='text'
																					onChange={this.handlers.textInputOnChange}
																					value={this.state.contactName}
																					style={{ height: 36 }} />
																			</FormGroup>
																		</Col>
																		: ''
																}
															</div>
															: ''
													}
													{
														selectedReportType === 'repairService' ?
															<Col sm={4}>
																<MultiSelectField
																	title={'狀態'}
																	multiSelectOptions={optsRepairStstus}
																	multiSelectedValues={selectedRepairStatus}
																	onChange={this.multiOtherSelectChangeHandler} />
															</Col>
															: ''
													}
													{
														(
															selectedReportType === 'repairService' ||
															selectedReportType === 'formExpense'
														) ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel={selectedReportType === 'formExpense' ? '申請日期-開始' : '填單日期-開始'}
																onChange={(date) => this.setState({ requestDateStart: date })}
																dayStateName='requestDateStart'
																dayValue={this.state.requestDateStart} />
															: null
													}
													{
														(
															selectedReportType === 'repairService' ||
															selectedReportType === 'formExpense'
														) ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel={selectedReportType === 'formExpense' ? '申請日期-結束' : '填單日期-結束'}
																onChange={(date) => this.setState({ requestDateEnd: date })}
																dayStateName='requestDateEnd'
																dayValue={this.state.requestDateEnd} />
															: null
													}
													{
														selectedReportType === 'repairService' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel={'結案日期-開始'}
																onChange={(date) => this.setState({ leaveTimeStart: date })}
																dayStateName='leaveTimeStart'
																dayValue={this.state.leaveTimeStart} />
															: null
													}
													{
														selectedReportType === 'repairService' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel={'結案日期-結束'}
																onChange={(date) => this.setState({ leaveTimeEnd: date })}
																dayStateName='leaveTimeEnd'
																dayValue={this.state.leaveTimeEnd} />
															: null
													}
													{
														selectedReportType === 'formInvoice' ?
															<Col sm={4}>
																<MultiSelectField
																	title={'類型'}
																	multiSelectOptions={optsInvoicePurpose}
																	multiSelectedValues={this.state.bInvoicePurpose}
																	onChange={this.multiOtherSelectChangeHandler} />
															</Col>
															: ''
													}
													{
														(
															selectedReportType === 'formLading' ||
															selectedReportType === 'formInvoice' ||
															selectedReportType === 'formGoods'
														) ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='寄送日期-開始'
																onChange={(date) => this.setState({ deliveryDateStart: date })}
																dayStateName='deliveryDateStart'
																dayValue={this.state.deliveryDateStart} />
															: null
													}
													{
														(
															selectedReportType === 'formLading' ||
															selectedReportType === 'formInvoice' ||
															selectedReportType === 'formGoods'
														) ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='寄送日期-結束'
																onChange={(date) => this.setState({ deliveryDateEnd: date })}
																dayStateName='deliveryDateEnd'
																dayValue={this.state.deliveryDateEnd} />
															: null
													}
													{
														(
															selectedReportType === 'formLading' ||
															selectedReportType === 'formInvoice'
														) ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='發票日期-開始'
																onChange={(date) => this.setState({ invoiceDateStart: date })}
																dayStateName='invoiceDateStart'
																dayValue={this.state.invoiceDateStart} />
															: null
													}
													{
														(
															selectedReportType === 'formLading' ||
															selectedReportType === 'formInvoice'
														) ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='發票日期-結束'
																onChange={(date) => this.setState({ invoiceDateEnd: date })}
																dayStateName='invoiceDateEnd'
																dayValue={this.state.invoiceDateEnd} />
															: null
													}
													{
														selectedReportType === 'formGoods' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='訂購日期-開始'
																onChange={(date) => this.setState({ purchaseDateStart: date })}
																dayStateName='purchaseDateStart'
																dayValue={this.state.purchaseDateStart} />
															: null
													}
													{
														selectedReportType === 'formGoods' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='訂購日期-結束'
																onChange={(date) => this.setState({ purchaseDateEnd: date })}
																dayStateName='purchaseDateEnd'
																dayValue={this.state.purchaseDateEnd} />
															: null
													}
													{
														selectedReportType === 'formGoods' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='需求日期-開始'
																onChange={(date) => this.setState({ contractDateStart: date })}
																dayStateName='contractDateStart'
																dayValue={this.state.contractDateStart} />
															: null
													}
													{
														selectedReportType === 'formGoods' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='需求日期-結束'
																onChange={(date) => this.setState({ contractDateEnd: date })}
																dayStateName='contractDateEnd'
																dayValue={this.state.contractDateEnd} />
															: null
													}
													{
														selectedReportType === 'formQuotation' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='報價日期-開始'
																onChange={(date) => this.setState({ quotationDateStart: date })}
																dayStateName='quotationDateStart'
																dayValue={this.state.quotationDateStart} />
															: null
													}
													{
														selectedReportType === 'formQuotation' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='報價日期-結束'
																onChange={(date) => this.setState({ quotationDateEnd: date })}
																dayStateName='quotationDateEnd'
																dayValue={this.state.quotationDateEnd} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='建立日期-開始'
																onChange={(date) => this.setState({ createDateStart: date })}
																dayStateName='createDateStart'
																dayValue={this.state.createDateStart} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='建立日期-結束'
																onChange={(date) => this.setState({ createDateEnd: date })}
																dayStateName='createDateEnd'
																dayValue={this.state.createDateEnd} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='開標日期-開始'
																onChange={(date) => this.setState({ openDateStart: date })}
																dayStateName='openDateStart'
																dayValue={this.state.openDateStart} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='開標日期-結束'
																onChange={(date) => this.setState({ openDateEnd: date })}
																dayStateName='openDateEnd'
																dayValue={this.state.openDateEnd} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='領取日期-開始'
																onChange={(date) => this.setState({ takeDateStart: date })}
																dayStateName='takeDateStart'
																dayValue={this.state.takeDateStart} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='領取日期-結束'
																onChange={(date) => this.setState({ takeDateEnd: date })}
																dayStateName='takeDateEnd'
																dayValue={this.state.takeDateEnd} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='到期日期-開始'
																onChange={(date) => this.setState({ dueDateStart: date })}
																dayStateName='dueDateStart'
																dayValue={this.state.dueDateStart} />
															: null
													}
													{
														selectedReportType === 'formMargin' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='到期日期-結束'
																onChange={(date) => this.setState({ dueDateEnd: date })}
																dayStateName='dueDateEnd'
																dayValue={this.state.dueDateEnd} />
															: null
													}
													{
														selectedReportType === 'formExpense' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='付款日期-開始'
																onChange={(date) => this.setState({ paymentDateStart: date })}
																dayStateName='paymentDateStart'
																dayValue={this.state.paymentDateStart} />
															: null
													}
													{
														selectedReportType === 'formExpense' ?
															<DayPicker
																labelFontWeight='bold'
																sm={2}
																// disabled={!editable}
																outerLabel='付款日期-結束'
																onChange={(date) => this.setState({ paymentDateEnd: date })}
																dayStateName='paymentDateEnd'
																dayValue={this.state.paymentDateEnd} />
															: null
													}
												</Row>
											</Col>
											: ''
									}
									<Col sm={12}>
										<Button className='btn-search'
											style={{ position: 'relative' }}
											onClick={this.onClickSend}
											disabled={
												!(
													selectedReportType === 'repairServiceReview' ||
													(
														this.state.deliveryDateStart &&
														this.state.deliveryDateEnd
													) ||
													(
														this.state.invoiceDateStart &&
														this.state.invoiceDateEnd
													) ||
													(
														this.state.purchaseDateStart &&
														this.state.purchaseDateEnd
													) ||
													(
														this.state.contractDateStart &&
														this.state.contractDateEnd
													) ||
													(
														this.state.quotationDateStart &&
														this.state.quotationDateEnd
													) ||
													(
														this.state.createDateStart &&
														this.state.createDateEnd
													) ||
													(
														this.state.openDateStart &&
														this.state.openDateEnd
													) ||
													(
														this.state.takeDateStart &&
														this.state.takeDateEnd
													) ||
													(
														this.state.dueDateStart &&
														this.state.dueDateEnd
													) ||
													(
														this.state.requestDateStart &&
														this.state.requestDateEnd
													) ||
													(
														this.state.leaveTimeStart &&
														this.state.leaveTimeEnd
													) ||
													(
														this.state.paymentDateStart &&
														this.state.paymentDateEnd
													)
												)
											}>
											{'查詢'}
											{
												(
													selectedReportType === 'repairServiceReview' ||
													(
														this.state.deliveryDateStart &&
														this.state.deliveryDateEnd
													) ||
													(
														this.state.invoiceDateStart &&
														this.state.invoiceDateEnd
													) ||
													(
														this.state.purchaseDateStart &&
														this.state.purchaseDateEnd
													) ||
													(
														this.state.contractDateStart &&
														this.state.contractDateEnd
													) ||
													(
														this.state.quotationDateStart &&
														this.state.quotationDateEnd
													) ||
													(
														this.state.createDateStart &&
														this.state.createDateEnd
													) ||
													(
														this.state.openDateStart &&
														this.state.openDateEnd
													) ||
													(
														this.state.takeDateStart &&
														this.state.takeDateEnd
													) ||
													(
														this.state.dueDateStart &&
														this.state.dueDateEnd
													) ||
													(
														this.state.requestDateStart &&
														this.state.requestDateEnd
													) ||
													(
														this.state.leaveTimeStart &&
														this.state.leaveTimeEnd
													) ||
													(
														this.state.paymentDateStart &&
														this.state.paymentDateEnd
													)
												)
													? ''
													:
													<Tooltip
														// placement='top'
														tipText={'請檢查日期是否有填寫'}
													/>
											}
										</Button>
									</Col>
								</Row>
						}
					</div>
					{
						isHideFilterPanel ?
							<Row>
								<Col sm={12} className='showFilterPanelIcon' onClick={this.onClickFilterPanelDown}>
									<span className='glyphicon glyphicon-menu-down'></span>
								</Col>
							</Row>
							: ''
					}
				</Panel>
				{
					showWorkLogPanel ?
						<Panel header={<h3>{tableTitle}</h3>} id='workLogPanel'>
							<ReportWorkLogTableCt
								// userName={this.props.userName}
								// reportType={selectedReportType} 
								// dataParam={dataParam}
								// isBigSideBar={this.props.isBigSideBar}
								// propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
								{...tableProps} />
						</Panel>
						: ''
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/report/ReportCt.jsx